import styled from 'styled-components';

export const StyledEditorBodyLayout = styled.div`
  display: flex;
  flex: 1;
  min-height: 0;
`;

export const StyledEditorCanvasArea = styled.main`
  flex: 1;
  min-width: 0;
  position: relative;
`;
